export { getUpstreamConditionalProperties } from './getUpstreamConditionalProperties'
